<script lang="typescript">
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import Fa from "svelte-fa";
import { slide } from "svelte/transition";
import { functions } from "../services/firebase";
export let offerID;
let display = "none";
let loading = false;
let error = ""
let shareKeys = [];
let shareableLink = ""
let copied = false;

export async function show() {
    const body = document.querySelector('body')
    const modal = document.querySelector('.modal')
    modal.classList.toggle('opacity-0')
    modal.classList.toggle('pointer-events-none')
    body.classList.toggle('modal-active')

    if(shareKeys.length === 0 && !modal.classList.contains("modal-active")){
        console.log("Active")
        loading = true;
        const shareKeysCallable = functions.httpsCallable("shareKeys");
        const shareKeysResult = await shareKeysCallable({offerID});
        loading = false;
        const links: firebase.default.firestore.QuerySnapshot<firebase.default.firestore.DocumentData>[] = shareKeysResult.data;
        console.log(links)
        if(links[0]){
            shareKeys = links;
            shareableLink = window.origin + "/offers/" + offerID + "?shareKey=" + shareKeys[0].id
        }
        // calls getShareLink, which will create one if there is none.
        // shareLink probably will belong to its own collection
        // that contains the UID, offerID, and read / write properties.
        // shareLink is then sent to backend for validation when visitor uses link.
    }
}
function copyLink (evt) {
  evt.preventDefault();
  const copyContents = shareableLink;
  var container = document.createElement('div');
  container.innerHTML = copyContents;
  container.style.position = 'fixed'
  container.style.pointerEvents = 'none'
  var activeSheets = Array.prototype.slice.call(document.styleSheets)
    .filter(function (sheet) {
      return !sheet.disabled
    })
  document.body.appendChild(container)
  window.getSelection().removeAllRanges()
  var range = document.createRange()
  range.selectNode(container)
  window.getSelection().addRange(range)
  document.execCommand('copy')
  for (var i = 0; i < activeSheets.length; i++) activeSheets[i].disabled = true
  document.execCommand('copy')
  for (var i = 0; i < activeSheets.length; i++) activeSheets[i].disabled = false
  document.body.removeChild(container)
  copied = true;
  setTimeout(()=>{
      copied = false;
  }, 2500)
}
</script>
<div 
transition:slide|local
class="modal opacity-0 pointer-events-none fixed w-full h-full top-0 left-0 flex items-center justify-center z-50">
    <div class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"></div>
    
    <div class="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto">
    
    <!-- <div class="modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm z-50">
        <svg class="fill-current text-white" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
        <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
        </svg>
        <span class="text-sm">(Esc)</span>
    </div> -->

    <!-- Add margin if you want to see some of the overlay behind the modal-->
    <div class="modal-content text-left ">
        <!--Title-->
        <div class="flex justify-between items-center pt-4 px-6 pb-3 bg-primary fill-current">
        <p class="text-2xl font-bold">Get a Shareable Link</p>
        <div on:click={show} class="modal-close bg-danger cursor-pointer p-4 z-50 rounded">
            <svg class="fill-current  text-white" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
            </svg>
        </div>
        </div>

        <!--Body-->
        <form id="newOfferForm" class="w3-container px-6 grid">
        {#if loading || shareKeys.length === 0}
            <div class="w-full text-center justify-center i pt-6">
                <i class="fas fa-spinner fa-spin fa-5x"></i> 
                <p>Loading</p>
            </div>
        {:else}
            <label for="offerName">Read-Only Link: </label>
            <div class="flex flex-row">
                <textarea name="shareableLink" 
                autocomplete="off"
                value={shareableLink}
                disabled={true} 
                class="border-black border-2 rounded flex-1" 
                type="text"/>
                <button 
                on:click={copyLink}
                class="
                text-white
                hover:bg-red-300 
                p-2 
                float-right
                tooltip
                mr-1
                
                rounded-lg flex-shrink">
                <Fa icon={faCopy} color="black" size="2x" swapOpacity={false} />
                <span class="tooltiptext">{copied ? "Copied!" : "Copy Link" }</span>
            </button>
            </div>
        {/if}
    
    </form>

        <!--Footer-->
        <div class="flex justify-end p-2 h-12">
        {error}
        </div>
    </div>
    </div>
</div>

<style>
.createOfferCard{
    max-width: 600px;
}

#newOfferModal span{
    background-color: red;
}
.w3-yellow {
    background-color: peachpuff !important;
}

footer {
    padding: 10px;
}

.modal {
transition: opacity 0.25s ease;
}
.modal-active {
    overflow-x: hidden;
    overflow-y: visible !important;
}

.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1000;
  top: 100%;
  left: 50%;
  margin-left: -60px;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>